export default __webpack_public_path__ + "static/media/apple-logo.7855f9e8.svg";